import { Entity, ThemeExposure } from '@api';
import { Toggle } from '@design/components/toggle/Toggle';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { PosthogTrackingSource } from '@terminal/services/tracking/posthog/constants';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { StepperSection } from '../components/stepper-section/StepperSection';
import styles from './ParentCategoryTab.module.scss';
import { ParentCategoryTable } from './parent-category-table/ParentCategoryTable';

interface ParentCategoryTabProps {
  entity: Entity;
  theme: ThemeExposure;
  source: PosthogTrackingSource;
}

export const ParentCategoryTab = ({
  entity,
  theme,
  source,
}: ParentCategoryTabProps) => {
  const { t } = useTranslation(['widget']);
  const [isExposureOnly, setIsExposureOnly] = useState(false);

  return (
    <div className={styles.root}>
      <StepperSection
        entity={entity}
        theme={theme}
        title={theme.theme.parent.name}
        activeIndex={2}
        rightHeaderNode={
          <div className={styles.toggleWrapper}>
            {t(
              'widget:assetOverview.knowledgeGraph.themeExposure.tabs.parentCategory.exposureOnly',
              {
                name: entity.name,
              }
            )}
            <Toggle isChecked={isExposureOnly} onToggle={setIsExposureOnly} />
          </div>
        }
      />
      <ErrorBoundaryWrapper>
        <ParentCategoryTable
          entityTag={entity.tag}
          isExposureOnly={isExposureOnly}
          parentThemeId={theme.theme.parent.id}
          childThemeId={theme.theme.id}
          source={source}
        />
      </ErrorBoundaryWrapper>
    </div>
  );
};
